import { FC, useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import { RotatingArrow } from 'dibs-elements/exports/RotatingArrow';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import styles from './SbRespRefineFilterDropdown.scss';

export type Props = {
    title: string;
    isApplied: boolean;
    filterName: string;
    currentOpenFilterName: string;
    setCurrentOpenFilterName: (s: string) => void;
};

export const SbRespRefineFilterDropdown: FC<Props> = ({
    title,
    children,
    isApplied,
    filterName,
    currentOpenFilterName,
    setCurrentOpenFilterName,
}) => {
    const { isDesktop } = useContext(ServerVarsContext);
    const [isButtonHovered, setIsButtonHovered] = useState(false);
    const [isDropdownHovered, setIsDropdownHovered] = useState(false);
    const [shouldRenderDropdown, setShouldRenderDropdown] = useState(false);
    const isOpen = currentOpenFilterName === filterName && (isButtonHovered || isDropdownHovered);
    useEffect(() => {
        setShouldRenderDropdown(true); // only render dropdown filters on client
    }, []);
    const buttonHandlers = isDesktop
        ? {
              // desktop handlers
              onClick: () => {
                  setIsButtonHovered(!isOpen);
              },
              onMouseEnter: () => {
                  setIsButtonHovered(true);
                  setCurrentOpenFilterName(filterName);
              },
              onMouseLeave: () => setIsButtonHovered(false),
          }
        : {
              // tablet handlers
              onClick: () => {
                  if (isOpen) {
                      setIsButtonHovered(false);
                      setIsDropdownHovered(false);
                  } else {
                      setIsButtonHovered(true);
                      setCurrentOpenFilterName(filterName);
                  }
              },
              onMouseLeave: () => setIsButtonHovered(false),
          };
    return (
        <div className={styles.container}>
            <div
                className={styles.buttonContainer}
                data-testid="sb-refine-filter-dropdown-button"
                {...buttonHandlers}
            >
                <div className={classNames(styles.button, { [styles.isApplied]: isApplied })}>
                    <div className={styles.title}>{title}</div>
                    <RotatingArrow direction={isOpen ? 'up' : 'down'} />
                </div>
                <div className={styles.hoverSpacer} />
            </div>
            {shouldRenderDropdown && (
                <div
                    onMouseEnter={() => setIsDropdownHovered(true)}
                    onMouseLeave={() => setIsDropdownHovered(false)}
                >
                    <div className={classNames(styles.dropdown, { [styles.isHidden]: !isOpen })}>
                        <div className={styles.body}>{children}</div>
                    </div>
                </div>
            )}
        </div>
    );
};
